import { preparePayloadForGraphQL } from '@/helpers/validate';

/**
 * Fields of `technicalReview` saved by the block project-technical-review-ac ("Techn. Prüfung -
 * AC") with their payload type (`preparePayloadForGraphQL`). Must match
 * `ProjectTechnicalReviewAcInput`.
 */
const PROJECT_TECHNICAL_REVIEW_AC_FIELD_TYPES = {
  acInspectedState: 'string',
  acNotes: 'string',
  expectedAcTimeExpenditureInSeconds: 'number',
  installationTeamNotes: 'string',
};

export const PROJECT_TECHNICAL_REVIEW_AC_INPUT_FIELDS = Object.keys(
  PROJECT_TECHNICAL_REVIEW_AC_FIELD_TYPES
);

/**
 * `ProjectTechnicalReviewAcInput` from the block object (or the unsaved project): the four fields
 * of `technicalReview`.
 */
export const toProjectTechnicalReviewAcInput = (project) =>
  preparePayloadForGraphQL(project.technicalReview ?? {}, PROJECT_TECHNICAL_REVIEW_AC_FIELD_TYPES);
